import React from 'react';
import AreaLandingPage, { AreaConfig } from '../components/AreaLandingPage';

const chembur: AreaConfig = {
  name: 'Chembur',
  slug: 'chembur',
  tagline: 'Doorstep Mobile Repair in Chembur, Mumbai',
  description:
    "Chembur on the Harbour line gets fast doorstep mobile repair from minto. Our certified technicians cover Chembur, Govandi, Mankhurd, Trombay, and surrounding areas. Screen or battery repair done at your doorstep.",
  localities: [
    'Chembur', 'Chembur Colony', 'RCF Colony', 'Diamond Garden',
    'Govandi', 'Mankhurd', 'Trombay', 'Chembur Naka', 'R.C.F. Township',
    'Tilak Nagar', 'Antop Hill', 'Wadala', 'Sion adjacent',
  ],
  zones: [
    {
      name: 'Chembur — Diamond Garden & Colony',
      line: 'Harbour Line',
      station: 'Chembur Station',
      localities: ['Chembur', 'Chembur Colony', 'Diamond Garden', 'Chembur Naka', 'Basant Park', 'Sindhi Society'],
      desc: 'Core Chembur fully covered. Our technicians are familiar with all CHS societies, bungalow colonies, and commercial areas in Chembur.',
    },
    {
      name: 'RCF Colony & Trombay',
      line: 'Harbour Line',
      station: 'Chembur Station',
      localities: ['RCF Colony', 'R.C.F. Township', 'Trombay', 'BARC Colony', 'Govandi East'],
      desc: "Government township areas including RCF Colony and Trombay are covered. We're experienced serving these gated campus areas.",
    },
    {
      name: 'Govandi & Mankhurd',
      line: 'Harbour Line',
      station: 'Govandi Station / Mankhurd Station',
      localities: ['Govandi', 'Mankhurd', 'Shivajinagar', 'Antop Hill', 'Deonar'],
      desc: 'Covering the Harbour line belt from Govandi to Mankhurd. Doorstep repair available across all localities in this zone.',
    },
    {
      name: 'Wadala & Antop Hill',
      line: 'Harbour Line',
      station: 'Wadala Road Station / Wadala Station',
      localities: ['Wadala', 'Wadala East', 'Wadala West', 'Antop Hill', "King's Circle", 'Sion adjacent'],
      desc: "Wadala on Mumbai's Harbour line is served by our Chembur team. Both residential and commercial repairs available.",
    },
  ],
  seo: {
    title: 'Mobile Repair in Chembur | Doorstep Phone Repair | minto',
    description:
      'Doorstep mobile repair in Chembur, Govandi, Mankhurd, Wadala & Trombay, Mumbai. Screen replacement, battery repair. Certified technicians, 90-day warranty. Book now!',
    keywords:
      'mobile repair Chembur, phone repair Chembur, screen repair Chembur, battery replacement Chembur, iPhone repair Chembur, Samsung repair Chembur, Govandi phone repair, Mankhurd mobile repair, Wadala phone repair, RCF Colony mobile repair, doorstep repair Chembur, Harbour line mobile repair',
  },
  faqs: [
    {
      q: 'Do you offer doorstep repair in Chembur Colony and Diamond Garden?',
      a: 'Yes, these are among our most requested locations in Chembur. Technician arrives within 60–90 minutes.',
    },
    {
      q: 'Can you repair phones in RCF Colony or Trombay?',
      a: 'Yes, we regularly service RCF Colony and Trombay including BARC township areas.',
    },
    {
      q: 'Do you also cover Govandi and Mankhurd?',
      a: 'Yes, Govandi and Mankhurd are part of our Chembur service zone on the Harbour line.',
    },
    {
      q: 'How much does iPhone battery replacement cost in Chembur?',
      a: 'iPhone battery replacement starts from ₹1,499. Select your model on the booking page for the exact price.',
    },
    {
      q: 'Is same-day repair available in Chembur?',
      a: 'Yes, book before 6 PM for a same-day visit from our technician.',
    },
  ],
};

const ChemburPage: React.FC = () => <AreaLandingPage area={chembur} />;
export default ChemburPage;
